module.exports = __webpack_public_path__ + "static/media/ic_sidemenu_product.36319c9d.svg";